import script from "./MyProfileChangeNameBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfileChangeNameBox.vue?vue&type=script&setup=true&lang=js"

import "./MyProfileChangeNameBox.vue?vue&type=style&index=0&id=6261162a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6261162a"]])

export default __exports__